// extracted by mini-css-extract-plugin
module.exports = {"setting":"styles_setting__1Reuk","title":"styles_title__3T9oK","body":"styles_body__1eMAB","content":"styles_content__OH8CL","caption":"styles_caption__3J5qi"};